let googleMapsApiKey = document.head.querySelector('meta[name="google-maps-api-key"]');
Vue.prototype.$googleMapsApi = googleMapsApiKey.content;

let apiUrl = document.head.querySelector('meta[name="api-url"]');
Vue.prototype.$apiUrl = apiUrl.content;

let stripePublicKey = document.head.querySelector('meta[name="stripe-public-key"]');
Vue.prototype.$stripePublicKey = stripePublicKey.content;

let getUrl = window.location;
Vue.prototype.$baseUrl = window.location.origin;

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
    Vue.prototype.$csrf_token = token.content;
} else {
    console.warn('Laravel-CSRF-Token not found!');
}